import * as Yup from "yup";

export const brandSchema = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
});
